export default class Spinner {
    constructor(elementToCover, options) {
        this.randomSpinnerId = crypto.randomUUID();
        const spinnerElement = this._createSpinner(options);
        spinnerElement.addStyles(this.randomSpinnerId, options);
        spinnerElement.addHtml(this.randomSpinnerId, elementToCover);
    }

    _createSpinner(options) {
        if (typeof options.type === 'string' && options.type === 'flower') {
            return new SpinnerFlower();
        }
        return new SpinnerCircle();
    }

    show() {
        document.getElementsByClassName(`curtain${this.randomSpinnerId}`)[0].style.display = 'flex';
    }

    hide() {
        document.getElementsByClassName(`curtain${this.randomSpinnerId}`)[0].style.display = 'none';
    }

}

class SpinnerCircle {
    addStyles(randomSpinnerId, options) {
        const style = document.createElement('style');
        const inactiveColor = typeof options.inactiveColor === 'string' ? options.inactiveColor : '#e0e0e0';
        const activeColor = typeof options.activeColor === 'string' ? options.activeColor : '#005CB0';
        style.textContent = `
        .curtain${randomSpinnerId} {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(54, 54, 64, 0.7);
            display: none;
            padding-top: 25vh;
            justify-content: center;
            z-index: 999999;
            box-sizing: border-box;
        }

        .curtain${randomSpinnerId} .spinner {
            width: 164px;
            height: 164px;
            border: 15px solid ${inactiveColor};
            border-top: 15px solid ${activeColor};
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            to { transform: rotate(360deg); }
        }`;
        document.head.appendChild(style);
    }

    addHtml(randomSpinnerId, elementToCover) {
        elementToCover.insertAdjacentHTML('afterbegin', `<div class="curtain${randomSpinnerId}"><div class="spinner"></div></div>`);
    }
}

class SpinnerFlower {
    addStyles(randomSpinnerId, options) {
        const style = document.createElement('style');
        const inactiveColor = typeof options.inactiveColor === 'string' ? options.inactiveColor : '#e0e0e0';
        const activeColor = typeof options.activeColor === 'string' ? options.activeColor : '#005CB0';
        const steps = typeof options.steps === 'number' ? parseInt(options.steps) : 12;

        const colors = this._generateGradient(activeColor, inactiveColor, steps);
        let petalStyle = '';
        const arch = Math.round(360 / steps);
        for(let i = 0; i < steps; i++){
            petalStyle += `.curtain${randomSpinnerId} .spinner .petal:nth-child(${i+1}) {transform: rotate(${arch*i}deg); background: ${colors[i]};}`;
        }

        style.textContent = `
        .curtain${randomSpinnerId} {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(54, 54, 64, 0.7);
            display: none;
            padding-top: 25vh;
            justify-content: center;
            z-index: 999999;
            box-sizing: border-box;
        }

        .curtain${randomSpinnerId} .spinner {
            position: relative;
            width: 300px;
            height: 300px;
            animation: rotate 3s linear infinite;
        }

        .curtain${randomSpinnerId} .spinner .petal {
            position: absolute;
            top: 60%;
            left: 50%;
            width: 3%;
            height: 20%;
            background: #005CB0;
            border-radius: 50% / 30%;
            transform-origin: center -32px;
        }

        ${petalStyle}

        @keyframes rotate {
            to {
                transform: rotate(360deg);
            }
        }`;
        document.head.appendChild(style);
    }

    addHtml(randomSpinnerId, elementToCover) {
        let petals = '';
        for(let i = 0; i < 12; i++){
            petals += '<div class="petal"></div>';
        }
        elementToCover.insertAdjacentHTML('afterbegin', `<div class="curtain${randomSpinnerId}"><div class="spinner">${petals}</div></div>`);
    }

    _hexToRgb(hex) {
        hex = hex.replace("#", "");
        const bigint = parseInt(hex, 16);
        return {
            r: (bigint >> 16) & 255,
            g: (bigint >> 8) & 255,
            b: bigint & 255
        };
    }

    _rgbToHex({ r, g, b }) {
        return "#" +
            [r, g, b].map(v =>
                v.toString(16).padStart(2, "0")
            ).join("");
    }

    _generateGradient(startHex, endHex, steps) {
        const start = this._hexToRgb(startHex);
        const end = this._hexToRgb(endHex);
        const gradient = [];

        for (let i = 0; i <= steps + 1; i++) {
            const t = i / (steps + 1);
            const r = Math.round(start.r + (end.r - start.r) * t);
            const g = Math.round(start.g + (end.g - start.g) * t);
            const b = Math.round(start.b + (end.b - start.b) * t);
            gradient.push(this._rgbToHex({ r, g, b }));
        }

        return gradient;
    }

}
